<template>
  <div class="bg-white box-shadow d-center-around pl-3 pr-3 pt-5 pb-5 mb-4 rounded">
    <div class="w-25 border-right">可提返利
      <h3 class="h3 text-link mt-3" @click="goForDetail('available')">
        &yen; {{Number(RebateInfo.canRebate).toFixed(2)}}
      </h3>
    </div>
    <div class="w-25 border-right">总计返利
      <h3 class="h3 text-link mt-3" @click="goForDetail('all')">&yen; {{Number(RebateInfo.allRebate).toFixed(2)}}</h3>
    </div>
    <div class="w-25 border-right">已提返利
      <h3 class="h3 text-link mt-3" @click="goForDetail('done')">&yen; {{Number(RebateInfo.rebated).toFixed(2)}}</h3>
    </div>
    <div class="w-25">冻结中
      <el-tooltip class="item" effect="dark" content="平台打款处理中" placement="top-start">
        <i class="el-icon-info h6 text-info"/>
      </el-tooltip>
      <h3 class="h3 text-link mt-3" @click="goForDetail('frozen')">&yen; {{Number(RebateInfo.freeze).toFixed(2)}}</h3>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'RebateTitle',
    computed:{
      ...mapState(['RebateInfo']),
    },
    methods: {
      //资金详细项点击跳转
      goForDetail(flag) {
        this.$router.replace({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            tab: flag
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
